export function getCookie(name: String) {
  return (document.cookie.match('(?:^|;)\\s*' + name.trim() + '\\s*=\\s*([^;]*?)\\s*(?:;|$)') ||
    [])[1];
}
